import {combineReducers} from "redux";
///view
import vn1Results from "./vn1Results";


const resultReducer = combineReducers({
    vn1Results,
});
export default resultReducer;